<div class="d-flex gap-2 acc-action-bar" [class]="getClass()">
  <ng-content></ng-content>
</div>
